import { Fragment, useEffect, useState } from 'react';
import { Footer, Header, HeaderTitle } from '.';
import { Intraday } from '../components'
import { useUrl } from '../hooks';

export const Layout = ({ children }) => {
    
    const url = useUrl()
    const [intraday, setIntraday] = useState(true) 
    
    useEffect(() => {
        const { param_0 } = url
        if (param_0 === 'chat') setIntraday(false)
        else setIntraday(true)
    }, [url])

    return (
        <Fragment>
            <main>
                <div className='main'>
                    {/* <HeaderTitle /> */}
                    <Header />
                    <div className='content'>{children}</div>
                    {intraday && <Intraday />}
                    <Footer />
                </div>
            </main>
        </Fragment>
    );
}